"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.UserPreferencesAPI = {
    getUserPreferences: function () {
        return index_1.axios.get('/api/v1/user/me/preferences').then(function (response) { return response.data.data; });
    },
    updateUserPreference: function (preferenceId, booleanValue, stringValue) {
        return index_1.axios.put("/api/v1/user/me/preferences/" + preferenceId, {
            booleanValue: booleanValue,
            stringValue: stringValue,
        });
    },
    getDevicePreferences: function () {
        return index_1.axios.get('/api/v1/device/me/preferences').then(function (response) { return response.data.data; });
    },
    updateDevicePreference: function (preferenceId, booleanValue, stringValue) {
        return index_1.axios.put("/api/v1/device/me/preferences/" + preferenceId, {
            booleanValue: booleanValue,
            stringValue: stringValue,
        });
    },
};
//# sourceMappingURL=UserPreferencesAPI.js.map